import * as React from "react";
import Svg, { Circle, Path } from "react-native-svg";
const CallingIcon = (props) => (
  <Svg
    width={32}
    height={32}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Circle cx={16} cy={16} r={16} fill={props.circleFill || "#2195F2"} />
    <Path
      d="M14.696 17.127C13.3371 15.7682 13.0303 14.4093 12.9611 13.8648C12.9417 13.7143 12.9935 13.5633 13.1012 13.4564L14.2009 12.3572C14.3627 12.1955 14.3914 11.9436 14.2701 11.7497L12.5192 9.03089C12.3851 8.81617 12.1096 8.73867 11.8832 8.85194L9.07237 10.1757C8.88927 10.2659 8.78157 10.4604 8.80236 10.6635C8.94964 12.0626 9.55962 15.5021 12.9397 18.8824C16.3198 22.2627 19.7588 22.8724 21.1587 23.0197C21.3617 23.0405 21.5563 22.9328 21.6464 22.7497L22.9702 19.9388C23.0831 19.7129 23.0061 19.4382 22.7923 19.3038L20.0735 17.5534C19.8797 17.432 19.6277 17.4605 19.4659 17.6222L18.3667 18.7218C18.2598 18.8295 18.1088 18.8813 17.9583 18.862C17.4138 18.7928 16.0549 18.4859 14.696 17.127V17.127Z"
      fill={props.fill || "white"}
    />
  </Svg>
);
export default CallingIcon;
